












































































































































































































































import {
  defineComponent,
  ref,
  PropType,
  computed,
  watch,
  onMounted,
} from '@vue/composition-api'
import AIcon from '@/components/AIcon'
import { mdiMagnify, mdiCircleOutline, mdiMenuRight } from '@mdi/js'
import {
  SearchResultCategory,
  SearchResultPage,
  SearchResultProduct,
  SearchResults,
} from '@/interfaces/Search'
import AButton from '@/components/AButton'
import ASearchResultProduct from './ASearchResultProduct.vue'
import { debouncedWatch } from '@vueuse/core'
import * as searchApi from '@/api/search'

export default defineComponent({
  name: 'ASearch',

  components: {
    AIcon,
    AButton,
    ASearchResultProduct,
  },

  props: {
    mock: {
      type: Boolean,
      default: false,
    },
    mockLoading: {
      type: Boolean,
      default: false,
    },
    query: {
      type: String,
      default: '',
    },
    products: {
      type: Object as PropType<SearchResults<SearchResultProduct>>,
      default: (): SearchResults => {
        return {
          total: 0,
          results: [],
        }
      },
    },
    categories: {
      type: Object as PropType<SearchResults<SearchResultCategory>>,
      default: (): SearchResults => {
        return {
          total: 0,
          results: [],
        }
      },
    },
    pages: {
      type: Object as PropType<SearchResults<SearchResultPage>>,
      default: (): SearchResults => {
        return {
          total: 0,
          results: [],
        }
      },
    },
  },

  setup(props) {
    const queryCopy = ref(props.query)
    const loading = ref(props.mockLoading)
    const showResults = ref(false)
    const resultsUrl = ref('#')
    const allProductsUrl = ref('#')
    const productRequestUrl = ref('#')
    const localProducts = ref<SearchResults<SearchResultProduct>>({
      total: 0,
      results: [],
    })

    const localCategories = ref<SearchResults<SearchResultCategory>>({
      total: 0,
      results: [],
    })

    const localPages = ref<SearchResults<SearchResultPage>>({
      total: 0,
      results: [],
    })
    
    if (!props.mock) {
      allProductsUrl.value = '/alle-produkte'
      productRequestUrl.value = '/ihr-wunschprodukt'
    }
    
    function resetResults() {
      localProducts.value.total = 0
      localProducts.value.results = []
      localCategories.value.total = 0
      localCategories.value.results = []
      localPages.value.total = 0
      localPages.value.results = []
    }
    
    watch(() => props.products, (newValue) => {
      localProducts.value = newValue
    })
    watch(() => props.categories, (newValue) => {
      localCategories.value = newValue
    })
    watch(() => props.pages, (newValue) => {
      localPages.value = newValue
    })
    watch(
      () => props.query,
      (query) => {
        queryCopy.value = query
        if (!query) {
          resetResults()
        }
      }
    )

    async function search() {
      if (!queryCopy.value) {
        return
      }
      if (props.mock) {
        showResults.value = true
        return
      }
      try {
        loading.value = true
        const { data } = await searchApi.search(queryCopy.value)
        if (data.query === queryCopy.value) {
          resultsUrl.value = data.resultsUrl
          localProducts.value.total = data.products.total
          localProducts.value.results = data.products.results
          localCategories.value.total = data.categories.total
          localCategories.value.results = data.categories.results
          localPages.value.total = data.pages.total
          localPages.value.results = data.pages.results
          loading.value = false
          showResults.value = true
        }
      } catch (err) {
        loading.value = false
        throw err
      }
    }

    onMounted(() => {
      search()
    })

    debouncedWatch(
      queryCopy,
      () => {
        if (queryCopy.value.length > 0) {
          search()
        } else {
          showResults.value = false
        }
      },
      { debounce: 300 }
    )

    const isLoading = computed(() => {
      if (props.mock) {
        return props.mockLoading
      }
      return loading.value
    })

    const focused = ref(false)

    function focusHandler() {
      focused.value = true
      if (queryCopy.value) {
        showResults.value = true
      }
    }

    const foundProducts = computed(() => {
      return localProducts.value.total > 0
    })

    const foundCategories = computed(() => {
      return localCategories.value.total > 0
    })

    const foundPages = computed(() => {
      return localPages.value.total > 0
    })

    const hasResults = computed(() => {
      if (foundProducts.value) {
        return true
      }
      if (foundCategories.value) {
        return true
      }
      return foundPages.value
    })

    const canNavigateToResults = computed(() => {
      if (isLoading.value) {
        return false
      }
      return queryCopy.value.length > 0
    })

    function navigateToResults() {
      console.log(canNavigateToResults.value, resultsUrl.value)
      if (canNavigateToResults.value && resultsUrl.value) {
        window.location.href = resultsUrl.value
      }
    }

    return {
      queryCopy,
      showResults,
      isLoading,

      focused,
      focusHandler,

      hasResults,
      foundProducts,
      foundCategories,
      foundPages,

      localProducts,
      localCategories,
      localPages,

      productRequestUrl,
      allProductsUrl,
      resultsUrl,
      canNavigateToResults,
      navigateToResults,

      mdiMagnify,
      mdiCircleOutline,
      mdiMenuRight,
    }
  },
})
